var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.noCol)?_c('el-col',{attrs:{"xs":24,"sm":24,"md":_vm.md,"lg":_vm.lg,"xl":_vm.xl}},[_vm._t("default")],2):_c('div',[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }